export type { TFullProgramContentsProps } from './types'
export { getFullProgramContentsData } from './api'
